var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ring-loader',{staticClass:"ring-loader",attrs:{"color":"#0080C5","loading":_vm.isLoading}}),_c('flash-message'),_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c(_vm.layout,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }